import type { IUiDialogHookCustomContent } from '@experiences/interfaces';
import React from 'react';

import { MigrationNotAvailableDialog } from '../../../common/migration/MigrationNotAvailableDialog';

interface OrgMigrationNotAvailableDialogProps extends IUiDialogHookCustomContent {
    errorCode?: string;
}

export const OrgMigrationNotAvailableDialog: React.FC<OrgMigrationNotAvailableDialogProps> = (props) => (
    <MigrationNotAvailableDialog
        {...props}
        notAvailableReasonKey="CLIENT_MIGRATION_NOT_AVAILABLE_REASON_1"
    />
);
